// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports

import { normalizeExtensions } from './normalize-extensions';
var STABLE_EMPTY_ARRAY = [];
export var getConfiguredApps = function getConfiguredApps(forgeExtensions, uiModificationsConfigs) {
  if (!forgeExtensions || !uiModificationsConfigs) {
    return STABLE_EMPTY_ARRAY;
  }

  // Put modules in the HashMap for a fast search & get by appEnvId
  var modulesHashMap = normalizeExtensions(forgeExtensions);
  return uiModificationsConfigs.filter(function (configuration) {
    return !!modulesHashMap[configuration.appEnvId];
  }).map(function (configuration) {
    return {
      forgeExtension: modulesHashMap[configuration.appEnvId],
      uiModificationsConfig: configuration.uiModifications.map(function (_ref) {
        var id = _ref.id,
          data = _ref.data;
        return {
          id: id,
          data: data
        };
      })
    };
  });
};